import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './AccountDetail.scss';
import { useAppSelector } from '@monorepo/shared';
import { selectDebugKey } from '@monorepo/shared/store/authSlice';
import bgBottom from '../../images/account/bg-1.svg';
import { BgTop } from '../../images/account/AccountBgTop';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';

export const Account = () => {
  const { pathname, state } = useLocation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const accountId = state?.account_id || currentAccount?.account_id;
  const debugKey = useAppSelector(selectDebugKey);
  const navigate = useNavigate();
  if (!accountId) {
    navigate(`/cred/ou`, {
      state: {
        debug_key: debugKey
      }
    });
  }
  return (
    <div className="account-container">
      <div className="image-layer">
        <img src={bgBottom} alt="Background Base" className="bg-image base" />
        {/* <img src={bgTop} alt="Background Fade" className="bg-image fade top" /> */}
        <BgTop />
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};
